import React, { useState } from 'react';
import '../styles/Login.css';

function Login({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [showRecovery, setShowRecovery] = useState(false);
  const [recoveryStep, setRecoveryStep] = useState(1);
  const [recoveryData, setRecoveryData] = useState({
    username: '',
    email: '',
    newPassword: '',
    confirmPassword: '',
    code: ''
  });
  const [sentCode, setSentCode] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');

    const users = {
      'admin': { password: 'admin123', role: 'Administrador', email: 'admin@terranet.com.ec' },
      'operador': { password: 'operador123', role: 'Operador', email: 'operador@terranet.com.ec' }
    };

    if (users[username] && users[username].password === password) {
      onLogin({ username, role: users[username].role });
    } else {
      setError('Usuario o contraseña incorrectos');
    }
  };

  const handleRecoverySubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccessMessage('');

    if (recoveryStep === 1) {
      // Validar usuario y correo
      const users = {
        'admin': { email: 'admin@terranet.com.ec' },
        'operador': { email: 'operador@terranet.com.ec' }
      };

      if (!users[recoveryData.username]) {
        setError('Usuario no encontrado');
        return;
      }

      if (users[recoveryData.username].email !== recoveryData.email) {
        setError('El correo no corresponde al usuario');
        return;
      }

      if (recoveryData.newPassword.length < 6) {
        setError('La contraseña debe tener al menos 6 caracteres');
        return;
      }

      if (recoveryData.newPassword !== recoveryData.confirmPassword) {
        setError('Las contraseñas no coinciden');
        return;
      }

      // Generar código de 4 dígitos
      const code = Math.floor(1000 + Math.random() * 9000).toString();
      setSentCode(code);

      // Enviar email (simulación - aquí iría la llamada al backend)
      try {
        const response = await fetch('http://10.100.253.58:8000/api/send-recovery-code', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            email: recoveryData.email,
            code: code,
            username: recoveryData.username
          })
        });

        if (response.ok) {
          setSuccessMessage(`Código enviado a ${recoveryData.email}`);
          setRecoveryStep(2);
        } else {
          // Si falla el backend, mostrar código en consola para testing
          console.log('Código de verificación:', code);
          setSuccessMessage(`Código de verificación: ${code} (revisar consola)`);
          setRecoveryStep(2);
        }
      } catch (err) {
        // Si no hay conexión con backend, mostrar código
        console.log('Código de verificación:', code);
        setSuccessMessage(`Código de verificación: ${code} (revisar consola)`);
        setRecoveryStep(2);
      }

    } else if (recoveryStep === 2) {
      // Verificar código
      if (recoveryData.code === sentCode) {
        setSuccessMessage('¡Contraseña cambiada exitosamente!');
        setTimeout(() => {
          setShowRecovery(false);
          setRecoveryStep(1);
          setRecoveryData({
            username: '',
            email: '',
            newPassword: '',
            confirmPassword: '',
            code: ''
          });
        }, 2000);
      } else {
        setError('Código incorrecto');
      }
    }
  };

  if (showRecovery) {
    return (
      <div className="login-container">
        <div className="login-background"></div>
        <div className="login-card">
          <div className="login-header">
            <img src="/logoTerranet2.png" alt="Terranet Logo" className="login-logo" />
            <h1>Recuperar Contraseña</h1>
            <p>Sistema de Gestión de Red de Fibra Óptica</p>
          </div>

          <form onSubmit={handleRecoverySubmit} className="login-form">
            {recoveryStep === 1 && (
              <>
                <div className="form-group">
                  <label htmlFor="rec-username">👤 Usuario</label>
                  <input
                    type="text"
                    id="rec-username"
                    value={recoveryData.username}
                    onChange={(e) => setRecoveryData({...recoveryData, username: e.target.value})}
                    placeholder="Ingrese su usuario"
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="rec-email">📧 Correo Terranet</label>
                  <input
                    type="email"
                    id="rec-email"
                    value={recoveryData.email}
                    onChange={(e) => setRecoveryData({...recoveryData, email: e.target.value})}
                    placeholder="usuario@terranet.com.ec"
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="rec-newpass">🔒 Nueva Contraseña</label>
                  <input
                    type="password"
                    id="rec-newpass"
                    value={recoveryData.newPassword}
                    onChange={(e) => setRecoveryData({...recoveryData, newPassword: e.target.value})}
                    placeholder="Mínimo 6 caracteres"
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="rec-confirm">🔒 Confirmar Contraseña</label>
                  <input
                    type="password"
                    id="rec-confirm"
                    value={recoveryData.confirmPassword}
                    onChange={(e) => setRecoveryData({...recoveryData, confirmPassword: e.target.value})}
                    placeholder="Repita la contraseña"
                    required
                  />
                </div>
              </>
            )}

            {recoveryStep === 2 && (
              <div className="form-group">
                <label htmlFor="rec-code">🔢 Código de Verificación</label>
                <input
                  type="text"
                  id="rec-code"
                  value={recoveryData.code}
                  onChange={(e) => setRecoveryData({...recoveryData, code: e.target.value})}
                  placeholder="Ingrese el código de 4 dígitos"
                  maxLength="4"
                  required
                />
                <small className="code-hint">Revisa tu correo: {recoveryData.email}</small>
              </div>
            )}

            {error && <div className="error-message">{error}</div>}
            {successMessage && <div className="success-message">{successMessage}</div>}

            <button type="submit" className="login-button">
              {recoveryStep === 1 ? 'Enviar Código' : 'Verificar y Cambiar'}
            </button>

            <button 
              type="button" 
              className="back-button"
              onClick={() => {
                setShowRecovery(false);
                setRecoveryStep(1);
                setError('');
                setSuccessMessage('');
              }}
            >
              ← Volver al inicio de sesión
            </button>
          </form>
        </div>
      </div>
    );
  }

  return (
    <div className="login-container">
      <div className="login-background"></div>
      <div className="login-card">
        <div className="login-header">
          <img src="/logoTerranet2.png" alt="Terranet Logo" className="login-logo" />
          <h1>GIS</h1>
          <p>Sistema de Gestión de Red de Fibra Óptica</p>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="username">👤 Usuario</label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Ingrese su usuario"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">🔒 Contraseña</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Ingrese su contraseña"
              required
            />
          </div>

          {error && <div className="error-message">{error}</div>}

          <button type="submit" className="login-button">
            Iniciar Sesión
          </button>

          <button 
            type="button" 
            className="forgot-password-button"
            onClick={() => setShowRecovery(true)}
          >
            ¿Olvidó su contraseña?
          </button>
        </form>
      </div>
    </div>
  );
}

export default Login;
